import { useState, useEffect, useCallback } from "react";
import { arrayMove } from "@dnd-kit/sortable";
import { useUpdateWitnessOrder } from "../../../../../../hooks/panelFilters/useUpdateWitnessOrder";
import { toastAlert } from "../../../../../../utils/AlertContext";

export const useWitnessReorder = ({ open, nota, token, onClose, refresh }) => {
  const [witnesses, setWitnesses] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const { updateWitnessOrder, loading } = useUpdateWitnessOrder(token);

  useEffect(() => {
    if (open && nota?.testigo) {
      const sorted = [...nota.testigo].sort(
        (a, b) => (a.orden_ref ?? 0) - (b.orden_ref ?? 0),
      );
      setWitnesses(sorted);
      setHasChanges(false);
    }
  }, [open, nota]);

  const handleDragEnd = useCallback(({ active, over }) => {
  if (!over || active.id === over.id) return;

  setWitnesses((current) => {
    const oldIdx = current.findIndex(
      (w) => String(w.witness_id) === String(active.id)
    );

    const newIdx = current.findIndex(
      (w) => String(w.witness_id) === String(over.id)
    );

    if (oldIdx === -1 || newIdx === -1) {
      return current;
    }

    setHasChanges(true);

    return arrayMove(current, oldIdx, newIdx);
  });
}, []);

  const handleSave = useCallback(async () => {
    const synthesisId = nota?.id_sintesis;
    if (!synthesisId) return;

    let allOk = true;

    for (let i = 0; i < witnesses.length; i++) {
      const witness = witnesses[i];
      const newOrder = i + 1;

      if (witness.orden_ref !== newOrder) {
        const result = await updateWitnessOrder(
          witness.witness_id,
          newOrder,
          synthesisId,
        );
        if (!result.success) {
          allOk = false;
          console.error(`Error reordenando testigo ${witness.witness_id}:`, result.message);
        }
      }
    }

    if (allOk) {
      toastAlert("Testigos reordenados correctamente", "success");
      refresh?.();
    } else {
      toastAlert("Algunos testigos no pudieron reordenarse", "warning");
    }

    onClose();
  }, [witnesses, nota, updateWitnessOrder, onClose, refresh]);

  return { witnesses, hasChanges, loading, handleDragEnd, handleSave };
};
